// Kenar Çubuğu Ayarları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'layout.sidebarSettings';

export const sidebarSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Kenar Çubuğu Ayarları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Soldaki menünün renklerini, uygulamanın tema renklerini ve menüde hangi başlıkların görüneceğini buradan ayarlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.sidebar`, 'Sidebar'),
    t(`${G}.nav.theme`, 'Tema'),
    t(`${G}.nav.buttons`, 'Butonlar'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Sidebar / Tema / Butonlar'),
    body: t(`${G}.regions.body`, 'Seçilen sekmenin ayarları'),
    footer: t(`${G}.regions.footer`, 'Otomatik kayıt notu'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Sekmeyi seçin'),
      text: t(`${G}.s1.text`, '"Sidebar" kenar çubuğunun arka plan ve yazı rengini, "Tema" uygulamadaki düğme ve vurgu renklerini, "Butonlar" menüde görünecek başlıkları ayarlar.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kenar çubuğu renkleri (Sidebar)'),
      text: t(`${G}.s2.text`, '"Arka Plan" sekmesinde renk seçiciden kenar çubuğunun rengini seçin; yandaki kutu sonucu gösterir. "Otomatik Yazı Rengi" açıkken yazı rengi arka plana göre okunaklı olacak şekilde kendiliğinden seçilir. Kendiniz seçmek için bu anahtarı kapatın; "Yazı Rengi" sekmesi açılır.'),
      tips: [
        t(`${G}.s2.tip1`, '"Varsayılan Renklere Dön" kenar çubuğu renklerini ilk hâline getirir ve otomatik yazı rengini yeniden açar.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Uygulama tema renkleri (Tema)'),
      text: t(`${G}.s3.text`, 'Primary ana düğmeler, başlıklar ve vurgular; Secondary ikincil düğmeler ve yardımcı öğeler; Accent bilgi mesajları ve vurgular için kullanılır. Her birini kendi sekmesinde seçin; alttaki "Önizleme" düğmelerin nasıl görüneceğini gösterir.'),
      tips: [
        t(`${G}.s3.tip1`, '"Varsayılan Tema Renklerine Dön" üç rengi de ilk hâline getirir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Menüde görünecekleri seçin (Butonlar)'),
      text: t(`${G}.s4.text`, 'Her ana başlığın yanındaki kutuyu işaretleyerek başlığı kenar çubuğunda gösterir ya da gizlersiniz. Ok simgesi başlığı açar; içindeki butonları tek tek işaretleyebilirsiniz. "Tümünü Seç" / "Tümünü Kaldır" ve alt bölümlerdeki "Tümü" / "Hiçbiri" hepsini birden değiştirir.'),
      tips: [
        t(`${G}.s4.tip1`, '"Pakette yok" etiketli başlıklar şirketinizin paketinde bulunmayan modüllerdir; açılamaz. Açtırmak için satış ekibiyle görüşün.'),
        t(`${G}.s4.tip2`, '"Varsayılan Ayarlara Dön" tüm başlıkları ve butonları yeniden görünür yapar.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydetmeye gerek yok'),
      text: t(`${G}.s5.text`, 'Kaydet düğmesi yoktur: her değişiklik anında uygulanır ve kaydedilir. Ayarlar bu tarayıcıda saklanır; başka bilgisayar veya tarayıcıda varsayılan görünüm gelir.'),
    },
  ],
});
